import React from "react";
import { User } from "../types/user";
import UserIcon from "./icons/UserIcon";
import "./UserBar.scss";

// Read-only mates bar (shared receipt): tap a mate to select them. Adding and
// editing mates happens in the mates table (before sharing) and the editor
// under this bar (after), never in the bar itself.
interface UserBarProps {
  users: User[];
  selectedUserIndex: number | null;
  setSelectedUserIndex: React.Dispatch<React.SetStateAction<number | null>>;
  // the mate this device says you are (guests)
  meId: string | null;
  // true for guests: tapping a mate also makes them "you" on this device. The
  // owner just selects (to paint shares), so passes false.
  identityEnabled: boolean;
  onSetMe: (userId: string | null) => void;
}

const UserBar: React.FC<UserBarProps> = ({
  users,
  selectedUserIndex,
  setSelectedUserIndex,
  meId,
  identityEnabled,
  onSetMe,
}) => {
  // selecting a user: hosts just paint; guests also become that mate (no
  // locking — any number of devices can be the same mate). There's no
  // deselecting: tapping the selected mate again keeps them, and you switch by
  // tapping someone else.
  const handleSelectUser = (index: number) => {
    const user = users[index];
    if (identityEnabled && user.id !== meId) onSetMe(user.id);
    setSelectedUserIndex(index);
  };

  return (
    <div className="user-bar-section">
      <div className="user-bar-row">
        <div className="user-bar">
          {users.map((user, index) => (
            <div key={user.id} className="user-icon-wrapper">
              <UserIcon
                user={user}
                selected={selectedUserIndex === index}
                onClick={() => handleSelectUser(index)}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UserBar;
